var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-dropdown',{attrs:{"options":_vm.INTERACTIONS_OPTIONS,"selected":_vm.selectedOption,"showLabel":true,"type":'options'},on:{"selectOption":function($event){return _vm.updateOption($event, 2)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }